/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { connectIslands } from '../../helpers';
import { CORNER_THICKNESS, Island, Islands } from '../../blueprint-classes';

export const setKitchenConnections = (islands: Islands, empty = false): void => {
	let galleyIsland: Island | null = null;
	const { defaultIslandId } = islands;


	// empty connections
	if (empty) {
		islands.children.forEach((island) => {
			island.connections.clear();
		});
	}

	const defaultIslandIndex = islands.children.findIndex((i) => i.id === defaultIslandId);
	let islandsBeforeDefault: Array<Island> = [];
	let islandsAfterDefault: Array<Island> = [];

	// console.log('schema:setKitchenConnections', islands);

	if (defaultIslandIndex > 0) {
		islandsBeforeDefault = (islands.children as Array<Island>)
			.slice(0, defaultIslandIndex)
			.reverse();
		// console.log('schema:islandsBeforeDefault:', islandsBeforeDefault);
	}

	if (defaultIslandIndex < islands.children.length) {
		islandsAfterDefault = defaultIslandIndex + 1 < islands.children.length
			? (islands.children as Array<Island>).slice(defaultIslandIndex + 1)
			: [];
		// console.log('schema:islandsAfterDefault:', islandsAfterDefault)
	}

	if (islandsBeforeDefault.length > 0) {
		let prevIsland = islands.getDefaultIsland();
		islandsBeforeDefault.forEach((island) => {
			// console.log('B@@@@@', defaultIslandId, island.id, prevIsland?.id);

			// anything left of angle 0 = 360 - angle
			const oIsland = island.axis.y > 180 ? 360 - island.axis.y : island.axis.y;
			const oPrevIsland = prevIsland.axis.y > 180 ? 360 - prevIsland.axis.y : prevIsland.axis.y;

			// Inline with the previous island if the orientations match or either island is a corner (45)
			const inline = oIsland === oPrevIsland || oIsland === 45 || oPrevIsland === 45
				? true
				: (oPrevIsland - 90 === oIsland) || (oPrevIsland + 90 === oIsland)
					? false
					: null;

			// console.log(inline, oIsland, oNextIsland);

			if (inline === null) {
				galleyIsland = defaultIslandId === island.id ? prevIsland : island;
			} else {
				connectIslands({
					sourcePanel: inline
						? island.panels.getFrontPanel().getRightPanel()
						: island.panels.getFrontPanel(),
					targetPanel: prevIsland.panels.getFrontPanel().getLeftPanel(),
					padding: 2 * CORNER_THICKNESS,
					offset: 0
				})
			}
			prevIsland = island;
		});

		// console.log('sorted island', {
		// 	sku: island.sku,
		// 	orientation: oIsland,
		// 	island: island.id,
		// 	connections: island.connections
		// });
	}

	if (islandsAfterDefault.length > 0) {
		let prevIsland = islands.getDefaultIsland();
		islandsAfterDefault.forEach((island, i) => {
			// console.log('A@@@@@', defaultIslandId, island.id, prevIsland?.id);
			if (prevIsland) {
				// anything left of angle 0 = 360 - angle
				const oIsland = island.axis.y > 180 ? 360 - island.axis.y : island.axis.y;
				const oPrevIsland = prevIsland.axis.y > 180 ? 360 - prevIsland.axis.y : prevIsland.axis.y;

				const inline = oIsland === oPrevIsland || oIsland === 45 || oPrevIsland === 45
					? true
					: (oPrevIsland - 90 === oIsland) || (oPrevIsland + 90 === oIsland)
						? false
						: null;

				// console.log(inline, oIsland, oNextIsland);

				if (inline === null) {
					galleyIsland = defaultIslandId === island.id ? prevIsland : island;
				} else {
					connectIslands({
						sourcePanel: inline
							? island.panels.getFrontPanel().getLeftPanel()
							: island.panels.getFrontPanel(),
						targetPanel: prevIsland.panels.getFrontPanel().getRightPanel(),
						padding: 2 * CORNER_THICKNESS,
						offset: 0
					})
				}
				prevIsland = island;
			}

			// console.log('sorted island', {
			// 	sku: island.sku,
			// 	orientation: oIsland,
			// 	island: island.id,
			// 	connections: island.connections
			// });
		})
	}

	if (galleyIsland !== null) {
		const island = islands.getDefaultIsland();
		connectIslands({
			sourcePanel: galleyIsland.panels.getFrontPanel(),
			targetPanel: island.panels.getFrontPanel(),
			padding: 48,
			offset: 0
		})
	}
};
